import { BatchChangeAuthMethodResult } from "../../../application/apis/tenant-management/types";
import { toErrorMessageForChangeAuthMethod } from "../../../application/domain/user/change-auth-method-error";
import { UserEntity } from "../../../application/domain/user/user-entity";

type TargetUser = {
  user: UserEntity;
};

type Props = {
  targetUsers: Array<TargetUser>;
  changeResult: BatchChangeAuthMethodResult;
};

export const BatchChangeAuthMethodResultTable: React.FC<Props> = ({
  targetUsers,
  changeResult,
}) => {
  const resultCell = (userId: string) => {
    const error = changeResult.errors.find((error) => error.userId === userId);
    if (error) {
      const message = toErrorMessageForChangeAuthMethod(error.errCode);
      return <td style={{ backgroundColor: "#fdfce6" }}>{message}</td>;
    }

    return <td>変更されました</td>;
  };

  return (
    <table className="table is-bordered is-fullwidth">
      <thead>
        <tr>
          <th>アカウント名</th>
          <th>結果</th>
        </tr>
      </thead>
      <tbody>
        {targetUsers.map((target) => (
          <tr key={target.user.id}>
            <td>{target.user.name}</td>
            {resultCell(target.user.id)}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
